<div class="border rounded">
  <div class="text-sm px-3 pt-3 flex items-center text-gray-lighter-text">
    <span class="mr-2"><Icon :width="13" :height="16" name="bubble-help"/></span>
    <span>{{ date.format('DD/MM/YYYY HH:mm') }}</span>
  </div>
  <div class="px-3 py-2">
    <slot></slot>
  </div>
</div>
